import React from 'react'
import PropTypes from 'prop-types'
import { Row } from 'react-styled-flexboxgrid-tmp'
import SvgIcon from 'Components/SvgIcon'

import {
  _NoFavorite,
  _ContentCol,
  _IconContainer,
} from './styles'

const NoFavourites = ({ building }) => {
  const copy = building ? 'Building' : 'Listing'
  const copyLower = copy.toLowerCase()
  return (
    <_NoFavorite>
      <h2>
        You don&apos;t have any favourite {copyLower}s yet!
      </h2>
      <Row>
        <_ContentCol xs={12} sm={4}>
          <_IconContainer>
            <SvgIcon name="#icon-favourite" width="50" height="50" />
          </_IconContainer>
          <h3>
            Favourite a {copy}
          </h3>
          <p>
            Click the favourite star on any {copyLower} to save it here.
          </p>
        </_ContentCol>

        <_ContentCol xs={12} sm={4}>
          <_IconContainer>
            <SvgIcon name="#icon-note" width="50" height="50" />
          </_IconContainer>
          <h3>
            View {copy}s
          </h3>
          <p>
            Access or remove your favourite {copyLower}s here.
          </p>
        </_ContentCol>

        {
          !building ?
            <_ContentCol xs={12} sm={4}>
              <_IconContainer>
                <SvgIcon name="#icon-share-final" width="50" height="50" />
              </_IconContainer>
              <h3>
                Share {copy}s
              </h3>
              <p>
                Email or print your favourite {copyLower}s from here.
              </p>
            </_ContentCol>
            :
            <_ContentCol xs={12} sm={4}>
              <_IconContainer>
                <SvgIcon name="#icon-bell" width="60" height="60" />
              </_IconContainer>
              <h3>
                Get Notifications
              </h3>
              <p>
                Get email notifications when your favourite {copyLower}s have
                new listings by setting up a Building Alert.
              </p>
            </_ContentCol>
        }
      </Row>
    </_NoFavorite>
  )
}
NoFavourites.propTypes = {
  building: PropTypes.bool,
}

export default NoFavourites
